import React from 'react'
import Button, { ButtonProps } from '@mui/material/Button/Button'
import { fonts } from '../../../../theme/theme'

export const MpSecondaryButton = (props: ButtonProps) => {
  const { sx, ...rest } = props

  return (
    <Button
      sx={{
        ...sx,
        ...fonts.Jakarta.Bold,
        color: 'primary.main',
        bgcolor: 'blue.50',
        textTransform: 'none',
      }}
      {...rest}
    />
  )
}
